/**
 * Sidebar Organism
 *
 * Menu lateral do admin
 */
import React from 'react'
import { NavLink, useLocation } from 'react-router-dom'
import {
	LayoutDashboard,
	Users,
	Building2,
	Calendar,
	MessageSquare,
	Star,
	Mail,
	Megaphone,
	FileText,
	LogOut,
	ChevronLeft,
	Settings,
} from 'lucide-react'
import useAdminStore from '../../core/admin.store'
import { SIDEBAR_ITEMS } from '../../core/admin.constants'
import { useAdminAuth } from '../../core/admin.hooks'

const iconMap = {
	LayoutDashboard,
	Users,
	Building2,
	Calendar,
	MessageSquare,
	Star,
	Mail,
	Megaphone,
	FileText,
	Settings,
}

export default function Sidebar() {
	const location = useLocation()
	const { sidebarOpen, toggleSidebar, admin } = useAdminStore()
	const { logout } = useAdminAuth()

	return (
		<aside
			className={`
				fixed left-0 top-0 h-screen bg-base-300 text-white
				transition-all duration-300 ease-in-out z-30
				${sidebarOpen ? 'w-50' : 'w-20'}
				flex flex-col
			`}
		>
			{/* Header */}
			<div className="flex items-center justify-between h-16 px-4 border-b border-base-200">
				{sidebarOpen && (
					<div className="flex items-center gap-2">
						<span className="text-2xl">⚽</span>
						<span className="text-lg font-bold text-primary-400">FutJá</span>
						<span className="text-xs bg-primary-600 px-2 py-0.5 rounded-full">Admin</span>
					</div>
				)}
				<button
					onClick={toggleSidebar}
					className="p-2 hover:bg-base-400 rounded-lg transition-colors"
				>
					<ChevronLeft className={`w-5 h-5 transition-transform ${!sidebarOpen ? 'rotate-180' : ''}`} />
				</button>
			</div>

			{/* Navigation */}
			<nav className="flex-1 overflow-y-auto py-4">
				<ul className="space-y-1 px-3">
					{SIDEBAR_ITEMS.map((item) => {
						const Icon = iconMap[item.icon]
						const isActive = location.pathname === item.path ||
							(item.path !== '/admin' && location.pathname.startsWith(item.path))

						return (
							<li key={item.id}>
								<NavLink
									to={item.path}
									className={`
                    flex items-center gap-3 px-3 py-2.5 rounded-lg transition-colors
                    ${isActive
											? 'bg-primary-500 text-white'
											: 'text-text-body hover:bg-base-400 hover:text-white'}
                  `}
								>
									{Icon && <Icon className="w-5 h-5 flex-shrink-0" />}
									{sidebarOpen && (
										<span className="text-sm font-medium">{item.label}</span>
									)}
								</NavLink>
							</li>
						)
					})}
				</ul>
			</nav>

			{/* Footer */}
			<div className="border-t border-base-200 p-4 mt-auto">
				{sidebarOpen && admin && (
					<div className="flex items-center gap-3 mb-4 px-2">
						<div className="w-10 h-10 rounded-full bg-primary-500 flex items-center justify-center">
							<span className="text-sm font-bold">
								{admin.name?.[0]?.toUpperCase() || 'A'}
							</span>
						</div>
						<div className="flex-1 min-w-0">
							<p className="text-sm font-medium truncate">{admin.name}</p>
							<p className="text-xs text-text-body truncate">{admin.role}</p>
						</div>
					</div>
				)}
				<button
					onClick={logout}
					className={`
            flex items-center gap-3 w-full px-3 py-2.5 rounded-lg
            text-text-body hover:bg-danger/20 hover:text-danger transition-colors
          `}
				>
					<LogOut className="w-5 h-5 flex-shrink-0" />
					{sidebarOpen && <span className="text-sm font-medium">Sair</span>}
				</button>
			</div>
		</aside>
	)
}
